module.exports = __webpack_public_path__ + "static/media/icon-edit-green.906052d2.svg";